import { JobseekerService } from '../shared/services/jobseeker.service';
import { OccupationCategory } from '@admin/shared/models/occupation-category.model';
import { JobseekerWorkexperienceModel } from '../shared/models/jobseeker-workexperience-model';
import {
  Component,
  OnInit,
  Input,
  OnChanges,
  SimpleChanges,
  EventEmitter,
  Output,
} from '@angular/core';
import { LookupService } from '@admin/shared/services/lookup.service';
import { Utils } from '@admin/shared/utils';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'hr-jobseeker-work-experience-item',
  templateUrl: './jobseeker-work-experience-item.component.html',
  styleUrls: ['./jobseeker-work-experience-item.component.less'],
  standalone: false,
})
export class JobseekerWorkExperienceItemComponent implements OnInit, OnChanges {
  @Input()
  public workExperience: JobseekerWorkexperienceModel;

  public get item() {
    return this.workExperience;
  }

  //@Input()
  public monthListShortMap: any;

  //@Input()
  public allCategories: OccupationCategory[];

  @Output()
  public onUpdate: EventEmitter<boolean> = new EventEmitter<boolean>();

  // @Input()
  public headCategoriesMap: { [index: number]: OccupationCategory };

  // @Input()
  // public childCategories: OccupationCategory[];

  public workExperienceHeadCategories: {
    headCategory: OccupationCategory;
    childCategories: OccupationCategory[];
  }[];

  public isEditModeOn: boolean;

  public getDownloadUrl() {
    return this.jobseekerService.getWorkExperienceAttachmentDownloadUrl(
      this.workExperience.jobseekerId
    );
  }

  public onEditWorkExperienceClick() {
    this.isEditModeOn = true;
  }

  public onDeleteWorkExperienceClick() {
    if (confirm(this.translateService.instant('message.AreYouSure'))) {
      this.jobseekerService
        .deleteJobseekerWorkExperience(this.workExperience)
        .subscribe((r) => {
          this.onUpdate.emit(true);
        });
    }
  }

  constructor(
    private lookupService: LookupService,
    private jobseekerService: JobseekerService,
    private translateService: TranslateService
  ) {}

  ngOnInit() {
    let lookupData = this.lookupService.getCachedLookupData();
    this.monthListShortMap = lookupData.monthListShort.reduce((a, b) => {
      a[b.value] = b.text;
      return a;
    }, {});
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.workExperienceHeadCategories = [];

    if (changes['workExperience'] != null && this.workExperience != null) {
      if (this.allCategories == null) {
        this.allCategories =
          this.lookupService.getCachedLookupData().occupationCategories;
      }
      if (this.headCategoriesMap == null) {
        this.buildHeadCategoryMap();
      }
      this.buildWorkExperienceHeadCategoryGrouping();
    }

    // if(changes['workExperience'] != null){
    //     this.buildWorkExperienceHeadCategoryGrouping();
    // }
  }

  public onWorkExperienceEdited() {
    this.onUpdate.emit(true);
  }

  public onCancelEditWorkExperience() {
    this.isEditModeOn = false;
  }

  public onDownloadWorkExperienceAttachmentClick(formId: string) {
    let form = <any>document.getElementById(formId);
    form.submit();
  }

  private buildHeadCategoryMap() {
    this.headCategoriesMap = [];
    this.allCategories.forEach((c) => {
      if (c.isHeadOld()) {
        this.headCategoriesMap[c.occupationCategoryId] = c;
      }
    });
  }

  private buildWorkExperienceHeadCategoryGrouping() {
    let w = this.workExperience;
    this.workExperienceHeadCategories = [];
    let categoryMap = Utils.toMap(
      this.allCategories,
      (c) => c.occupationCategoryId
    );

    if (this.workExperience.categories) {
      let grouping = this.workExperience.categories.reduce((v, c) => {
        let headId = categoryMap[c.category.occupationCategoryId].headId;
        v[headId] = v[headId] || [];
        v[headId].push(c);
        return v;
      }, {});

      for (let key in grouping) {
        this.workExperienceHeadCategories.push({
          headCategory: this.headCategoriesMap[key],
          childCategories: grouping[key],
        });
      }
    }
  }
}
